import { createApi } from "@ametie/vue-muza-use";
import { useToast } from "@app/core";
import * as Sentry from "@sentry/vue";
import { createPinia } from "pinia";
import { createApp } from "vue";

import App from "./App.vue";
import router from "./router";

import "@app/core/style.css";

import "./main.scss";
import { isSilencedApiError } from "@/shared/config/apiErrors.ts";
import { myAxios } from "@/shared/config/axios.ts";
import { toolsAxios } from "@/shared/config/toolsAxios.ts";

const { error } = useToast();
const pinia = createPinia();
const app = createApp(App);
const isSentryEnabled = import.meta.env.VITE_SENTRY_ENABLED?.toUpperCase() === "TRUE";
const sentryDSN = import.meta.env.VITE_SENTRY_DSN;

if (isSentryEnabled) {
  Sentry.init({
    app,
    dsn: sentryDSN,
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.3,
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 0.3,
  });
}

app.use(pinia);
app.use(router);

app.use(createApi({
  axios: myAxios,
  clients: { tools: toolsAxios },
  devtools: { enabled: import.meta.env.VITE_MUZA_USE_DEVTOOLS?.toUpperCase() === "TRUE" },
  onError: (errorMessage, cause) => {
    if (isSilencedApiError(errorMessage.message, cause)) return;
    error(errorMessage.message);
  },
  globalOptions: {
    cacheDefaults: {
      swr: true,
      staleTime: "5h",
      freshFor: "1h",
    },
  },
}));

// Mount the app
app.mount("#app");
